import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { PublishedPage } from '@/components/PublishedPage'
import { getDomain } from '@/utils/route-utils'
import { getDomainPort } from '@/utils/route-utils'

export const Route = createFileRoute('/_protected/_site/published')({
  component: RouteComponent,
})

function RouteComponent() {
  const routeApi = getRouteApi("/_protected/_site")
  const data = routeApi.useLoaderData()

  const siteUrl = `https://${data.subdomain}.${getDomain()}${getDomainPort()}`

  return <PublishedPage siteUrl={siteUrl} />
}
